var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"container"},[_c('p',[_vm._v(" Copyright © 2016-"+_vm._s(_vm.year)+" Garage Rats Car Club. All Rights Reserved. ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }